export default __webpack_public_path__ + "static/media/img.232486e7.png";